import styled from "styled-components";

export const TickBulletPoint = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-start;
  align-items: center;
  color: ${(props) => props.theme.colors.default[900]};
  font-size: 16px;
  font-style: normal;
  font-weight: 550;
  line-height: normal;
  div {
    svg {
      color: ${(props) => props.theme.colors.primary.default};
    }
  }
`;
